import React from 'react';
import { Select } from 'antd';
import { SelectProps } from 'antd/es/select';
import { EPromoType, EPromoTypeText } from 'entities/Promo/Promo.models';

interface IComponentProps {
  onChange?: (value?: EPromoType) => void;
  value?: EPromoType;
  placeholder?: string;
}

type AllProps = SelectProps<any> & IComponentProps;

export class PromoTypeSelector extends React.PureComponent<AllProps> {
  handleChange = (value: EPromoType) => {
    const { onChange } = this.props;
    onChange && onChange(value);
  };

  render() {
    const { value, placeholder } = this.props;
    return (
      <Select
        allowClear
        className="width-full"
        placeholder={placeholder}
        value={value}
        defaultActiveFirstOption={false}
        onChange={(value: EPromoType) => this.handleChange(value)}
      >
        <Select.Option key={EPromoType.Action} value={EPromoType.Action} label={EPromoTypeText.Action}>
          {EPromoTypeText.Action}
        </Select.Option>
        <Select.Option key={EPromoType.Code} value={EPromoType.Code} label={EPromoTypeText.Code}>
          {EPromoTypeText.Code}
        </Select.Option>
      </Select>
    );
  }
}
